module.exports = __webpack_public_path__ + "img/sectionLeftIcn.0a1757ee.png";